import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import styled from 'foundations-theming/utils';
import TopLevelLogicGroupToggle from '../viewer/TopLevelLogicGroupToggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VerticalConnector = styled.div.withConfig({
  displayName: "LogicGroupsDivider__VerticalConnector",
  componentId: "sc-1lddzv7-0"
})(({
  theme
}) => ({
  inlineSize: theme.borderWidth[100],
  blockSize: theme.space[400],
  backgroundColor: theme.color['border-core-default']
}));
const LogicOperatorContainer = styled.div.withConfig({
  displayName: "LogicGroupsDivider__LogicOperatorContainer",
  componentId: "sc-1lddzv7-1"
})(({
  theme
}) => ({
  border: `${theme.borderWidth[100]} solid ${theme.color['border-core-default']}`,
  borderRadius: theme.borderRadius[100]
}));
const StyledFormattedMessage = styled(FormattedMessage)(({
  theme,
  isDisabled
}) => ({
  color: isDisabled ? theme.color['text-core-disabled'] : undefined
}));
const MessageKeys = {
  [LogicGroupNames.AND]: 'newCustomerDataFilters.logicOperator.and',
  [LogicGroupNames.OR]: 'newCustomerDataFilters.logicOperator.or'
};
const LogicGroupsDivider = props => {
  const {
    logicOperator,
    layout = 'horizontal',
    paddingBlockStart = '400',
    paddingBlockEnd = '400',
    showToggle = false,
    isLast = false,
    showLogicGroupOperatorToggles = false
  } = props;
  if (!logicOperator) {
    return null;
  }
  const dividerText = showToggle ? /*#__PURE__*/_jsx(TopLevelLogicGroupToggle, {}) : /*#__PURE__*/_jsx(StyledFormattedMessage, {
    isDisabled: showLogicGroupOperatorToggles,
    message: MessageKeys[logicOperator]
  });
  if (layout === 'vertical') {
    return /*#__PURE__*/_jsx(Flex, {
      padding: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        paddingInlineStart: "600",
        children: [/*#__PURE__*/_jsx(VerticalConnector, {}), /*#__PURE__*/_jsx(LogicOperatorContainer, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "div",
            color: "text-core-default",
            typography: "heading-50",
            paddingBlock: showToggle ? '0' : '250',
            paddingInline: showToggle ? '0' : '500',
            children: dividerText
          })
        }), !isLast && /*#__PURE__*/_jsx(VerticalConnector, {})]
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingBlockStart: paddingBlockStart,
    paddingBlockEnd: paddingBlockEnd,
    children: [/*#__PURE__*/_jsx(HR, {
      marginBlockStart: "0",
      marginBlockEnd: "0"
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      color: "text-core-default",
      textTransform: "uppercase",
      typography: "heading-100",
      paddingInline: showToggle ? '0' : '400',
      children: dividerText
    }), /*#__PURE__*/_jsx(HR, {
      marginBlockStart: "0",
      marginBlockEnd: "0"
    })]
  });
};
export default LogicGroupsDivider;